import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class ThemeserviceService {
  
  constructor(@Inject(DOCUMENT) private readonly document:Document) { }

  loadClientStylesheet(folder_id:any): void {
    const head = this.document.getElementsByTagName('head')[0];
    const link = this.document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `assets/tenant-specific/${folder_id}/css/${folder_id}.css`;
    head.appendChild(link);
  }
}

